function toutou_xy_solaire(myJson, zoom) {
    //Argument optionel
    if (zoom != null) var my_zoom = zoom;
    else var my_zoom = 0;
    // Donnees de MySQL
    var ni = myJson.hhh.length;
    var data = new Array(ni);
    var hhh = new Array(ni);
    var aaaammjj = myJson.aaaammjj;
    var hh = myJson.hh;
    var datev = dateo;
    var my_fonts = new Toutou_Fonts();
    var tr = new Toutou_Transform();
    var nptcub = 9;
    data[0] = 0.;
    hhh[0] = myJson.hhh[0];
    for(var i = 1; i < ni; i++)hhh[i] = myJson.hhh[i];
    data = jouleparm2_accumule_a_wattparm2(myJson.data1, hhh);
    // Espace autour de la boite du graphique en %
    var pil_w = .08;
    var pil_e = .01;
    var pil_s = .2;
    var pil_n = .15;
    ctx = set_canvas('toutou_xy_solaire');
    tr.xrange(my_zoom, hhh);
    tr.ymax = data.max();
    dimx = tr.xmax - tr.xmin;
    tr.xmin = tr.xmin - .02 * dimx;
    tr.xmax = tr.xmax + .02 * dimx;
    tr.ymin = 0.0;
    dimy = tr.ymax - tr.ymin;
    tr.ymax = tr.ymax + .02 * gxsize / gysize * dimy;
    incy = 100;
    tr.ymax = Math.ceil(tr.ymax / incy) * incy;
    tr.ymin = 0.;
    nj = (tr.ymax - tr.ymin) / incy + 1.;
    tr.pix_margeg = Math.round(pil_w * gxsize) + .5;
    tr.pix_marged = Math.round((1. - pil_e) * gxsize) + .5;
    tr.pix_margeh = Math.round(pil_n * gysize) + .5;
    tr.pix_margeb = Math.round((1. - pil_s) * gysize) + .5;
    tr.init(my_zoom);
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, gxsize, gysize);
    // Titre principal
    ctx.font = my_fonts.principal;
    ctx.fillStyle = "#33A";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText("Date de d\xe9part : " + toutou_xy_titre_principal(dateo), .5 * (tr.xmax_pix + tr.xmin_pix), 0);
    ctx.restore();
    // Titre secondaire
    ctx.font = my_fonts.legende;
    ctx.fillStyle = "blue";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillText("Radiation solaire moyenne durant les deux heures indiqu\xe9es de chaque c\xf4t\xe9 des bandes [Watt/m2]", tr.xmin_pix, tr.ymax_pix - 2);
    // xticks
    tr.xticks_jours(datev, hhh, ctx, my_fonts, my_zoom);
    // yticks
    ctx.beginPath();
    ctx.font = my_fonts.axis;
    ctx.fillStyle = "Black";
    ctx.strokeStyle = 'black';
    ctx.textAlign = "right";
    ctx.textBaseline = "middle";
    xx = Math.round(tr.xmin_pix - .01 * (tr.xmax_pix - tr.xmin_pix)) + .5;
    for(var i = 0; i < nj; i++){
        yy = Math.round(tr.d2py(tr.ymin + i * incy)) + .5;
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(xx, yy);
        ctx.fillText(Math.ceil(tr.ymin) + i * incy + ' ', xx, yy);
    }
    ctx.stroke();
    // Lignes grises
    ctx.strokeStyle = '#bbb';
    for(var i = 1; i < nj - 1; i++){
        yy = Math.round(tr.d2py(tr.ymin + i * incy)) + .5;
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(tr.xmax_pix, yy);
        ctx.stroke();
    }
    // Tracer flux solaire
    ctx.beginPath();
    ctx.fillStyle = 'blue';
    ctx.strokeStyle = 'blue';
    espace = (tr.d2px(hhh[1]) - tr.d2px(hhh[0])) * .1;
    for(i = Math.max(1, tr.xind_min); i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]) - espace;
        yy = tr.d2py(data[i]);
        ctx.fillRect(xx, yy, tr.d2px(hhh[i - 1]) - tr.d2px(hhh[i]) + 2 * espace, tr.d2py(0.) - yy);
    }
    ctx.stroke();
}

//# sourceMappingURL=imeteo.1f662f46.js.map
